import styled from "styled-components";
import React, { ReactNode } from "react";

const FlexContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: -12vh;
`;

const Subtitle = styled.h1`
    font-family: "Noto Sans Display", sans-serif;
    font-style: italic;
    text-align: center;
    margin: 0;
    font-size: calc(1.5vw + 3vh);
    background: yellow;
    padding: .2vw;
    text-wrap: nowrap;
`;

const FancySubtitle = (props: {children: ReactNode}) => {
    return <FlexContainer>
        <Subtitle>{props.children}</Subtitle>
    </FlexContainer>
}

export default FancySubtitle;